module.exports = __webpack_public_path__ + "img/27_72.37c8e62b.png";